export function bytesToMb(bytes) {
    return `${bytes / 1024 / 1024}Mb`;
}